var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockActive = function SvgLockActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.8,
    height: 29.8,
    x: 7.326,
    y: 2.63,
    fill: "#7CBFD4",
    stroke: "currentColor",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D0F1FC",
    d: "M9 6a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v22.5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M18 10.5 9 6v4l9 4zM18 19l-9-4v2.5l9 3.688z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0F1FC",
    stroke: "#030303",
    d: "M16.385 12.644c.722.04 1.484.17 2.153.323.823.19 1.451.404 1.665.51 1.212.606 2.852 1.076 4.323 1.16.736.043 1.459-.01 2.075-.21.62-.201 1.17-.568 1.473-1.173.246-.492.381-.947.416-1.348.034-.394-.027-.772-.223-1.066a1.01 1.01 0 0 0-.93-.46c-.356.025-.687.22-.964.497-.028.027-.105.08-.277.128a3 3 0 0 1-.659.091c-.546.026-1.242-.025-2.015-.136a28.6 28.6 0 0 1-4.637-1.104c-2.225-.742-4.62-.926-5.559-.926a3.2 3.2 0 1 0 3.16 3.714Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C3948",
    fillRule: "evenodd",
    d: "M14.098 24.506a1.8 1.8 0 1 0-1.744 0 1 1 0 0 0-.028.224v2.7a.9.9 0 1 0 1.8 0v-2.7a1 1 0 0 0-.028-.224",
    clipRule: "evenodd"
  })));
};
export default SvgLockActive;